if (window.location.search.includes('d-active')) {
  document.querySelector('.drawer').classList.add('active');
}

function addToCart(e) {
  let variant = e.dataset.variant;

  let sectionsToUpdate = 'ajax-cart';

  let requestBody = {
    items: [
      {
        id: variant,
        quantity: 1,
      },
    ],
    sections: sectionsToUpdate,
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      window.location.href = window.location.pathname + '?d-active=true';
    })
    .catch((error) => {
      console.error('Error:', error);
    });

}
